const themeStyles = colors => {
  const styles = {
    container: {
      display: 'flex',
      justifyContent: 'center'
    },
    carouselContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: 185,
      height: 20
    },
    button: {
      background: 'none',
      border: 'none'
    },
    icon: {
      fontSize: '13.88px',
      color: colors.primary,
      cursor: 'pointer'
    },
    dotContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    dot: {
      boxSizing: 'border-box',
      height: 4,
      width: 4,
      borderRadius: '4px',
      backgroundColor: '#CCCCCC',
      marginLeft: 2.5,
      marginRight: 2.5,
      borderWidth: 0
    }
  }
  styles.oneDotCarouselContainer = {
    ...styles.carouselContainer,
    justifyContent: 'center'
  }
  styles.dotSelected = { ...styles.dot, backgroundColor: colors.primary }
  return styles
}

export default themeStyles
